import { render } from "./OpportunityCreatedReport.vue?vue&type=template&id=41aa0f7c&scoped=true"
import script from "./OpportunityCreatedReport.vue?vue&type=script&lang=js"
export * from "./OpportunityCreatedReport.vue?vue&type=script&lang=js"

import "./OpportunityCreatedReport.vue?vue&type=style&index=0&id=41aa0f7c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa0f7c"]])

export default __exports__